// Ensure final price or initial payment always at bottom of list
const sortBreakdown = (breakdown) =>
  [...breakdown].sort((a, b) => {
    const { key } = b;

    if (key === 'final_price' || key === 'initial_payment') {
      return -1;
    }

    return 0;
  });

export default sortBreakdown;
